/** Use the recorded language, retaining historical wording and avoiding repeated prefixes. */
export function productName(product) {
    const languages = {
        EN: "EN", ENG: "EN", ENGLISH: "EN",
        JP: "JP", JA: "JP", JPN: "JP", JAPANESE: "JP",
        CN: "CN", ZH: "CN", CHINESE: "CN",
        KR: "KR", KO: "KR", KOREAN: "KR",
    };
    const language = languages[product.language?.trim().toUpperCase() ?? ""];
    if (!language)
        return product.name;
    return `${language} ${product.name.trim().replace(/^(?:(?:EN|JP|CN|KR)[\s-]+)+/i, "")}`;
}
//# sourceMappingURL=product-name.js.map